import { Injector } from "@angular/core";
import { BaseNode } from "../../BaseNode";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { DrugIndicationEntity } from "../../../Data/MedicinalProductData/DrugIndicationEntity";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";

export class TreeNodeDrugIndicationEntity extends BaseNode {

    constructor(injector: Injector, labelTemplate: string, parent: BaseNode, model: any) {
        super(injector, new DrugIndicationEntity(injector,model), labelTemplate);
        this.parent=parent;
        this.ioc!.get(Art57Section).generateNumColumValue(this);
    }

    public getListItem(): any[] {
        return [this.ioc?.get(LookupGetService).retrieveValueFromCache('supportedbacklogmeddraversions', this.data.model.meddraversion),
                this.ioc?.get(LookupGetService).retrieveValueFromCache('meddraLevel', this.data.model.meddralevel),
                this.data.model.meddracode.value, this.data.model.meddracode.name];
    }

}